import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { AmmDashboardApi } from '@models/RutersApi';
import { WebService } from '@services/web.service';
import {
  EditableLabelRegistryEntry,
  EditableLabelsMap,
  EditableLabelsMapResponse,
  EditableLabelTranslation,
  EditableLabelTranslationsBulkUpsert,
} from '@models/EditableLabels/editable-labels.model';

@Injectable({
  providedIn: 'root',
})
export class EditableLabelsService {
  private static readonly BASE_PATH = `${environment.apiUrl}/editable-labels`;

  constructor(private webService: WebService) {}

  getAllOverrides(): Observable<Record<string, EditableLabelsMap>> {
    return this.webService
      .httpGet<EditableLabelsMapResponse>(EditableLabelsService.BASE_PATH)
      .pipe(map((res) => res?.labelsByLanguage || {}));
  }

  listRegistry(): Observable<EditableLabelRegistryEntry[]> {
    return this.webService.httpGet<EditableLabelRegistryEntry[]>(AmmDashboardApi.EDITABLE_LABELS);
  }

  createLabel(key: string, description: string): Observable<EditableLabelRegistryEntry> {
    return this.webService.httpPost<EditableLabelRegistryEntry>(AmmDashboardApi.EDITABLE_LABELS, {
      key,
      description,
    });
  }

  listTranslations(key: string, tenantDomain: string): Observable<EditableLabelTranslation[]> {
    return this.webService.httpGet<EditableLabelTranslation[]>(this.translationsPath(key, tenantDomain));
  }

  upsertTranslations(
    key: string,
    tenantDomain: string,
    translations: { language: string; value: string; enabled: boolean }[],
  ): Observable<EditableLabelTranslation[]> {
    const body: EditableLabelTranslationsBulkUpsert = { translations };
    return this.webService.httpPut<EditableLabelTranslation[]>(this.translationsPath(key, tenantDomain), body);
  }

  private translationsPath(key: string, tenantDomain: string): string {
    return AmmDashboardApi.EDITABLE_LABEL_TRANSLATIONS.replace('{tenant}', tenantDomain).replace(
      '{key}',
      encodeURIComponent(key),
    );
  }
}
